import logo from './assets/Data6.png';
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
      </header>
      <div className='contact'>
        contact info: <b>admin@data6.com</b>
      </div>
    </div>
  );
}

export default App;
